export enum BatchDateHandling {
  Replace = 0,
  Shift = 1,
  Week = 2
}

export const BatchDateHandlingMapping: Record<BatchDateHandling, string> = {
  [BatchDateHandling.Replace]: 'Replace',
  [BatchDateHandling.Shift]: 'Shift',
  [BatchDateHandling.Week]: 'Week'
};
